"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import React, { forwardRef, Children, Fragment as Fragment$1 } from 'react';
import { Button } from '../../../ui-kit/button.mjs';
import { IntegrationAvatar } from '../IntegrationAvatar/index.mjs';

const IntegrationItem = forwardRef(({ integration, children, asChild, ...props }, ref) => {
  const hasDirectChild = Boolean(children && Children.only(children) && React.isValidElement(children));
  const directDescendant = hasDirectChild ? children : /* @__PURE__ */ jsx(Fragment$1, {});
  return /* @__PURE__ */ jsx(
    Button,
    {
      ref,
      variant: "subtle",
      className: "flex flex-col-reverse justify-center items-center gap-2 max-h-[initial] h-[initial] min-h-28 p-3 pt-5 rounded-md whitespace-normal bg-white hover:bg-[revert-layer]",
      ...props,
      asChild: asChild && hasDirectChild,
      children: React.cloneElement(directDescendant, {
        children: /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("span", { className: "text-gray-12 text-xs leading-[1.125rem]", children: integration.name }),
          /* @__PURE__ */ jsx(IntegrationAvatar, { integration })
        ] })
      })
    }
  );
});

export { IntegrationItem };
